// extracted by mini-css-extract-plugin
export default {"Tag":"SoonTag_Tag__Ye-Uz"};